/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { NumericTrackItDataTypeFilterDto } from './NumericTrackItDataTypeFilterDto';
import {
    instanceOfNumericTrackItDataTypeFilterDto,
    NumericTrackItDataTypeFilterDtoFromJSON,
    NumericTrackItDataTypeFilterDtoFromJSONTyped,
    NumericTrackItDataTypeFilterDtoToJSON,
} from './NumericTrackItDataTypeFilterDto';

/**
 * @type CreateNumericEvaluationParameterDtoTrackItFilter
 * 
 * @export
 */
export type CreateNumericEvaluationParameterDtoTrackItFilter = NumericTrackItDataTypeFilterDto;


export function CreateNumericEvaluationParameterDtoTrackItFilterFromJSON(json: any): CreateNumericEvaluationParameterDtoTrackItFilter {
    return CreateNumericEvaluationParameterDtoTrackItFilterFromJSONTyped(json, false);
}

export function CreateNumericEvaluationParameterDtoTrackItFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericEvaluationParameterDtoTrackItFilter {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...NumericTrackItDataTypeFilterDtoFromJSONTyped(json, true) };
    return  NumericTrackItDataTypeFilterDtoFromJSONTyped(json, true);
}

export function CreateNumericEvaluationParameterDtoTrackItFilterToJSON(value?: CreateNumericEvaluationParameterDtoTrackItFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfNumericTrackItDataTypeFilterDto(value)) {
        return NumericTrackItDataTypeFilterDtoToJSON(value as NumericTrackItDataTypeFilterDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateNumericEvaluationParameterDtoTrackItFilter interface.
 */
export function instanceOfCreateNumericEvaluationParameterDtoTrackItFilter(value: any): value is CreateNumericEvaluationParameterDtoTrackItFilter {
    if (instanceOfNumericTrackItDataTypeFilterDto(value)) return true;
    return false;
}

